import { manufacturingFetch } from "@/lib/manufacturingClient";

export type SlotLabelLineScope = "unlabeled" | "labeled" | "all";

export type SlotCleanupMaterialLine = {
  line_id: string;
  recipe_id: string;
  recipe_code: string;
  recipe_name: string;
  recipe_kind: string;
  material_id: string | null;
  material_code: string;
  material_name: string;
  quantity: number;
  slot_label: string;
};

/** @deprecated Prefer SlotCleanupMaterialLine */
export type UnlabeledRecipeLine = SlotCleanupMaterialLine;

export type SlotLabelUsage = {
  label: string;
  line_count: number;
  attachment_count: number;
};

export function listManufacturingSlotCleanupLines(scope: SlotLabelLineScope = "unlabeled") {
  const q = new URLSearchParams({ scope });
  return manufacturingFetch<{
    ok: true;
    scope: SlotLabelLineScope;
    lines: SlotCleanupMaterialLine[];
  }>(`/api/mfg/slot-labels/unlabeled?${q.toString()}`, { method: "GET" });
}

/** @deprecated Prefer listManufacturingSlotCleanupLines */
export function listManufacturingUnlabeledSlotLines() {
  return listManufacturingSlotCleanupLines("unlabeled");
}

export function listManufacturingSlotLabelInventory() {
  return manufacturingFetch<{ ok: true; labels: SlotLabelUsage[] }>(
    "/api/mfg/slot-labels/inventory",
    { method: "GET" },
  );
}

export function applyManufacturingSlotLabel(payload: {
  line_ids: string[];
  slot_label: string;
}) {
  return manufacturingFetch<{ ok: true; updated: number }>("/api/mfg/slot-labels/apply", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export type SlotLabelsBulkApplySummary = {
  updated: number;
  skipped: Array<{ row: number; reason: string }>;
};

export function bulkApplyManufacturingSlotLabels(payload: {
  rows: Array<{
    line_id?: string | null;
    recipe_code?: string;
    material_code?: string;
    material_name?: string;
    line_quantity?: number | null;
    slot_label: string;
  }>;
}) {
  return manufacturingFetch<{ ok: true; summary: SlotLabelsBulkApplySummary }>(
    "/api/mfg/slot-labels/bulk-apply",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function renameManufacturingSlotLabel(payload: {
  from_label: string;
  to_label: string;
}) {
  return manufacturingFetch<{
    ok: true;
    lines_updated: number;
    attachments_updated: number;
  }>("/api/mfg/slot-labels/rename", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
